import { getFreeTrialUrl, CREATE_FREE_TRIAL_PATH, EXTERNAL_API_ACCESS_KEY } from "./api.constants";


export const createFreeTrialAccount  = async (formData) => {
  const response = await fetch(`${getFreeTrialUrl()}/${CREATE_FREE_TRIAL_PATH}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "ExternalAccessKey": EXTERNAL_API_ACCESS_KEY },
    body: JSON.stringify(formData),
  });
  return await response.json();
}

